"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainAppSettings = void 0;
var GameEnd_1 = require("./GameEnd");
var CreateGameForm_1 = require("./create/CreateGameForm");
var GameHome_1 = require("./GameHome");
var GamesOverview_1 = require("./GamesOverview");
var PlayerHome_1 = require("./PlayerHome");
var SpectatorHome_1 = require("./SpectatorHome");
var StartScreen_1 = require("./StartScreen");
var LoadGameForm_1 = require("./LoadGameForm");
var DebugUI_1 = require("./DebugUI");
var Help_1 = require("./help/Help");
var i18n_1 = require("../directives/i18n");
var constants = require("../constants");
var raw_settings = require("../genfiles/settings.json");
var dialogPolyfill = require('dialog-polyfill');
exports.mainAppSettings = {
    'el': '#app',
    'data': {
        screen: 'empty',
        playerkey: 0,
        settings: raw_settings,
        isServerSideRequestInProgress: false,
        componentsVisibility: {
            'millestones_list': true,
            'awards_list': true,
            'tags_concise': false,
            'pinned_player_0': false,
            'pinned_player_1': false,
            'pinned_player_2': false,
            'pinned_player_3': false,
            'pinned_player_4': false,
            'turmoil_parties': false,
            'global_event_deck': true,
        },
        game: undefined,
        logPaused: false,
    },
    'components': {
        'start-screen': StartScreen_1.StartScreen,
        'create-game-form': CreateGameForm_1.CreateGameForm,
        'load-game-form': LoadGameForm_1.LoadGameForm,
        'game-home': GameHome_1.GameHome,
        'player-home': PlayerHome_1.PlayerHome,
        'spectator-home': SpectatorHome_1.SpectatorHome,
        'player-end': GameEnd_1.GameEnd,
        'games-overview': GamesOverview_1.GamesOverview,
        'debug-ui': DebugUI_1.DebugUI,
        'help': Help_1.Help,
    },
    'methods': {
        showAlert: function (message, cb) {
            if (cb === void 0) { cb = function () { }; }
            var dialogElement = document.getElementById('alert-dialog');
            var buttonElement = document.getElementById('alert-dialog-button');
            var messageElement = document.getElementById('alert-dialog-message');
            if (buttonElement !== null && messageElement !== null && dialogElement !== null && dialogElement.showModal !== undefined) {
                messageElement.innerHTML = i18n_1.$t(message);
                var handler_1 = function () {
                    buttonElement.removeEventListener('click', handler_1);
                    cb();
                };
                buttonElement.addEventListener('click', handler_1);
                dialogElement.showModal();
            }
            else {
                alert(message);
                cb();
            }
        },
        setVisibilityState: function (targetVar, isVisible) {
            if (isVisible === this.getVisibilityState(targetVar))
                return;
            this.componentsVisibility[targetVar] = isVisible;
        },
        getVisibilityState: function (targetVar) {
            return this.componentsVisibility[targetVar] ? true : false;
        },
        updatePlayer: function () {
            var currentPathname = window.location.pathname;
            var xhr = new XMLHttpRequest();
            var app = this;
            xhr.open('GET', '/api/player' +
                window.location.search.replace('&noredirect', ''));
            xhr.onerror = function () {
                alert('Error getting game data');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    app.player = xhr.response;
                    app.playerkey++;
                    if (app.player.game.phase === 'end' &&
                        window.location.search.includes('&noredirect') === false) {
                        app.screen = 'the-end';
                        if (currentPathname !== '/the-end') {
                            window.history.replaceState(xhr.response, constants.APP_NAME + " - Player", '/the-end?id=' + app.player.id);
                        }
                    }
                    else {
                        app.screen = 'player-home';
                        if (currentPathname !== '/player') {
                            window.history.replaceState(xhr.response, constants.APP_NAME + " - Game", '/player?id=' + app.player.id);
                        }
                    }
                }
                else if (xhr.status === 401) {
                    alert('Incorrect password.\n(If you accidentally closed your player page, check your browser\'s History > Recently Closed tabs.)');
                }
                else {
                    alert('Unexpected server response');
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        updateSpectator: function () {
            var xhr = new XMLHttpRequest();
            var app = this;
            xhr.open('GET', '/api/spectator' +
                window.location.search);
            xhr.onerror = function () {
                alert('Error getting game data');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    app.spectator = xhr.response;
                    app.playerkey++;
                    app.screen = 'spectator-home';
                    window.history.replaceState(xhr.response, constants.APP_NAME + " - Game", '/spectator?id=' + app.spectator.id);
                }
                else {
                    alert('Unexpected server response');
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
    },
    'mounted': function () {
        document.title = constants.APP_NAME;
        dialogPolyfill.default.registerDialog(document.getElementById('alert-dialog'));
        var currentPathname = window.location.pathname;
        var app = this;
        if (currentPathname === '/player' || currentPathname === '/the-end') {
            app.updatePlayer();
        }
        else if (currentPathname === '/game') {
            app.screen = 'game-home';
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open('GET', '/api/game' + window.location.search);
            xhr_1.onerror = function () {
                alert('Error getting game data');
            };
            xhr_1.onload = function () {
                if (xhr_1.status === 200) {
                    window.history.replaceState(xhr_1.response, constants.APP_NAME + " - Game", '/game?id=' + xhr_1.response.id);
                    app.game = xhr_1.response;
                }
                else {
                    alert('Unexpected server response');
                }
            };
            xhr_1.responseType = 'json';
            xhr_1.send();
        }
        else if (currentPathname === '/games-overview') {
            app.screen = 'games-overview';
        }
        else if (currentPathname === '/new-game' || currentPathname === '/solo') {
            app.screen = 'create-game-form';
        }
        else if (currentPathname === '/load') {
            app.screen = 'load';
        }
        else if (currentPathname === '/debug-ui' || currentPathname === '/cards') {
            app.screen = 'cards';
        }
        else if (currentPathname === '/help') {
            app.screen = 'help';
        }
        else if (currentPathname === '/spectator') {
            app.updateSpectator();
        }
        else {
            app.screen = 'start-screen';
        }
    },
};
//# sourceMappingURL=App.js.map